import { Component, ChangeDetectorRef, HostListener } from '@angular/core';
import { Subscription } from "rxjs";
import { NavController, ModalController, Platform } from '@ionic/angular';

import { UrlConstant } from './Constant';

import { EventService } from './service/event.service';
import { AuthService } from './service/auth.service';
import { ApiService } from './service/api.service';
import { DownloadService } from './service/download.service';
import { WarningService } from './service/warning.service';

import { DownloadModalPage } from './page/download-modal/download-modal.page';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent
{
    public template_type = 'default';
    public show_menu: boolean = false;
    public open_menu: boolean = false;

    private getlist_subs: Subscription;
    private show_progress_subs: Subscription;
    private show_progress_empty_subs: Subscription;
    private show_progress_badge_subs: Subscription;
    private modal_subs: Subscription;

    private show_hidden_file = false;
    private show_list = false;
    private folder_list = [];
    private show_progress = false;
    private show_progress_empty = false;
    private show_progress_body = false;
    private show_badge = 0;

    private component_modal = null;
    public resize_event: any = null;
    public screen_wid: number = 0;
    public menu_subs: any = null;
    public open_menu_subs: any = null;

    private modal_ids = [];
    private is_back = false;

    private zipcomp_cnt = 0;

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private nav: NavController,
        private modalCtrl: ModalController,
        private platform: Platform,
        private event: EventService,
        private auth: AuthService,
        private api: ApiService,
        private download: DownloadService,
        private warning: WarningService
    ) {
    }

   ngOnInit()
    {
        this.resize_event = this.platform.resize.subscribe(() => {
            this.screen_wid = this.platform.width();

            if (this.screen_wid < 992) {
                this.event.menu_button_subject.next(true);
                this.open_menu = false;
            } else {
                this.event.menu_button_subject.next(false);
                this.open_menu = false;
            }
        });

        this.getlist_subs = this.event.getlistSubject.subscribe(async(data) => {
            await this.getFolderList();
            await this.changeDetectorRef.detectChanges();
        });
        this.show_progress_subs = this.event.showProgressSubject.subscribe(async(data) => {
            await this.setShowProgress(data);
            await this.changeDetectorRef.detectChanges();
        });
        this.show_progress_empty_subs = this.event.showProgressEmptySubject.subscribe(async(data) => {
            await this.setShowProgressEmpty(data);
            await this.changeDetectorRef.detectChanges();
        });
        this.show_progress_badge_subs = this.event.showProgressBadgeSubject.subscribe(async(data) => {
            await this.setShowProgressBadge(data);
            await this.changeDetectorRef.detectChanges();
        });
        this.menu_subs = this.event.menuSubject.subscribe(async(data: any) => {
            this.show_menu = (data ? true : false);
        });
        this.open_menu_subs = this.event.openMenuSubject.subscribe(async(data: any) => {
            this.open_menu = true;
        });

        this.modal_subs = this.event.modalSubject.subscribe(async(data) => {
            switch(data.key) {
                case "modalSubscribe":
                    this.modalSubscribe(data.id);
                    break;
                case "closeModal":
                    this.closeModal(data.id, data.value);
                    break;
                default:
                    break;
            }
        });

        this.initData();
    }

    ngOnDestroy()
    {
        if (this.resize_event) {
            this.resize_event.unsubscribe();
        }
        if (this.getlist_subs) {
            this.getlist_subs.unsubscribe();
        }
        if (this.show_progress_subs) {
            this.show_progress_subs.unsubscribe();
        }
        if (this.show_progress_empty_subs) {
            this.show_progress_empty_subs.unsubscribe();
        }
        if (this.show_progress_badge_subs) {
            this.show_progress_badge_subs.unsubscribe();
        }
        if (this.menu_subs) {
            this.menu_subs.unsubscribe();
        }
        if (this.open_menu_subs) {
            this.open_menu_subs.unsubscribe();
        }
        if (this.modal_subs) {
            this.modal_subs.unsubscribe();
        }
    }

    closeSideMenu()
    {
        this.open_menu = false;
    }

    async modalSubscribe(id)
    {
        this.modal_ids.push(id);
        this.is_back = false;
        this.setHistoryState(id);
    }

    setHistoryState(id)
    {
        const modalState = {
            modal : true,
            desc : `Fake state for ${id}`
        };
        history.pushState(modalState, null);
    }

    @HostListener('window:popstate', ['$event'])
    modalDismiss()
    {
            if (this.is_back === false && this.modal_ids.length > 0) {
                const id = this.modal_ids[this.modal_ids.length - 1];
                this.closeModal(id, null);
            } else {
                this.is_back = false;
            }
    }

    closeModal(id, data)
    {
        this.is_back = true;

        const idx = this.modal_ids.findIndex((v) => v == id);

        if (idx >= 0) {
            this.modal_ids.splice(idx, 1);
            const elm = document.getElementById(id);

            if (elm != null) {
                this.modalCtrl.dismiss(data, "", id);

                if (this.modal_ids.length > 0) {
                    this.setHistoryState(this.modal_ids[this.modal_ids.length-1]);
                }

                if (window.history.state.modal) {
                    history.back();
                }
            }
        }
    }

    async initData()
    {
        this.show_hidden_file = await this.auth.getSettings('show_hidden_file');
    }

    async getFolderList()
    {
        this.screen_wid = this.platform.width();

        if (this.screen_wid < 992) {
            this.event.menu_button_subject.next(true);
        } else {
            this.event.menu_button_subject.next(false);
        }

        const list = await this.api.getfilelist("");

        if (!this.api.isSuccess('getfilelist:')) {
            this.api.setErrorToast('getfilelist:');

            if (this.api.isAuthErr('getfilelist:')) {
                await new Promise(resolve => setTimeout(resolve, 2000));
                await this.auth.redirectToDefault(true);
            }
            return;
        }

        this.folder_list = [];

        list.map((v) => {
            if (v.file_flg == 0 && v.trash_flg == 0) {
                this.folder_list.push(v);
            }
        });

        await this.event.getlist_res_subject.next(true);
        await this.getZiparchives();
        await this.warning.register();
    }

    async getZiparchives()
    {
        this.zipcomp_cnt = 0;
        const dl_list = await this.api.zipprogress();

        dl_list.map((v) => {
            if (v.percent >= 100) this.zipcomp_cnt++;
        });
    }

    async openDownload()
    {
        if (!this.auth.empty(this.component_modal)) return;
        this.component_modal = 0;

        this.closeSideMenu();

        this.component_modal = await this.modalCtrl.create({
            component: DownloadModalPage,
            id: 'download-modal',
            cssClass: 'download-modal',
            backdropDismiss: false,
            swipeToClose: true,
            mode: 'ios'
        });

        this.component_modal.onDidDismiss().then(async(ret) => {
            this.component_modal = null;
            if (ret !== null && !this.auth.empty(ret.data)) {
                const data = ret.data;
                await this.download.zipdownload(data.file);

                setTimeout(() => { this.getZiparchives(); }, 3000);
            }
        });

        await this.component_modal.present();
    }

    async onChangeShowHiddenFile(event)
    {
        this.show_hidden_file = event.target.checked;
        await this.auth.setSettings('show_hidden_file', event.target.checked);
        this.event.show_hidden_subject.next(this.show_hidden_file);
        this.closeSideMenu();
    }

    openList()
    {
        this.show_list = (this.show_list === true ? false : true);
    }

    async moveAction(file)
    {
        this.closeSideMenu();

        if (file == null) {
            await this.auth.removeSettings(`file_search_word::`);
            this.nav.navigateRoot(`/file`);
        } else {
            await this.auth.removeSettings(`file_search_word::${file.id}`);
            this.nav.navigateRoot(`/file/${file.id}`);
        }
    }

    async movePage(page)
    {
        await this.auth.removeSettings(`${page}_search_word::`);
        this.closeSideMenu();
        this.nav.navigateRoot(`/${page}`);
    }

    setShowProgress(show)
    {
        if (show === false) this.show_badge = 0;
        this.show_progress = show;
    }

    setShowProgressEmpty(show)
    {
        this.show_progress_empty = show;
    }

    setShowProgressBadge(cnt: any)
    {
        this.show_badge = cnt;
    }

    setShowProgressBody()
    {
        if (this.show_progress_body === false) {
            this.show_progress_body = true;
        } else {
            this.show_progress_body = false;
        }
    }

    openHowto()
    {
        window.open(UrlConstant.HOWTO_URL, '_bkank');
    }

    setTemplate(type)
    {
        this.template_type = type;
    }
}
